import { Box, Button, Container, styled } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '12.5%',
    left: '27.5%',
    width: '45%',
    bgcolor: 'background.paper',
    textAlign: 'center',
    borderRadius: '15px',
};

const ModalLabel = styled(Box)(() => ({
    backgroundColor: '#41DBCE',
    fontSize: '1.3rem',
    color: '#FFFFFF',
    height: '2.2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
    boxSizing: `content-box`,
}));

const CancelButton = styled(Button)(() => ({
    backgroundColor: '#BFBFBF',
    color: '#000000',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '8rem',
    borderRadius: '100rem'
}));

const DlButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '12rem',
    borderRadius: '100rem',
    marginLeft: '1rem'
}));

const ModalScroll = styled(Box)(() => ({
    maxHeight: '70vh',
    overflowY: 'auto'
}));

const formCommon = {
    border: '2px solid #01CFBE',
    padding: '16px',
    width: '90%',
};

const itemLabel = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#01CFBE !important',
    textAlign: 'left',
    marginLeft: '10px',
    marginTop: '-10px'
};

const itemRadio = {
    justifyContent: 'left',
    gap: '40px',
    ml: "50px",
    marginTop: '-5px'
};

const itemBox = {
    mt: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    ml: '50px',
    marginTop: '5px',
    posision: 'relative'
};

const inputBox = {
    height: '35px',
    fontSize: '18px',
    border: '1px solid #D0D0D0',
    color: '#FFF',
    backgroundColor: '#595959',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

const inputField = {
    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' },
    '& .MuiInputBase-input': { fontSize: '18px' }
};

const explainText = {
    fontSize: '14px',
    textAlign: 'left',
    marginLeft: '50px',
    marginTop: '5px',
    color: '#000 !important'
};

const FieldChoice = {
    border: '2px solid #d0d0d0',
    height: '230px',
    width: '80%',
    mt: 2,
    display: "flex",
    alignItems: "left",
    ml: "50px",
    marginTop: '5px',
    flexDirection: "column",
    overflowY: 'auto',
    pl: 2
};

export { modalStyle, ModalLabel, CancelButton, DlButton, ModalScroll, formCommon, itemLabel, itemRadio, itemBox, inputBox, inputField, explainText, FieldChoice }
